import React, { useState, useEffect, useCallback } from 'react';
import { PAGESIZE, AMBIENTE } from '../constantes/constantes';
import { generateSessionId } from '../functions/functions';
import Paginacion from './paginacion/Paginacion';
import Loading from './loading/Loading';
import BusquedaForm from './busquedaForm/BusquedaForm';
import Resultados from './resultados/Resultados';
import { getSearch } from '../services/getSearch';
import { postToken } from '../services/postToken';
import PaginacionMobile from './paginacion/paginacionMobile';

export default function BuscadorApp() {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('');
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [showLoading, setShowLoading] = useState(true);
  const [errorService, setErrorService] = useState(false);
  const [retrySearch, setRetrySearch] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('sessionToken'));
  const [retryCount, setRetryCount] = useState(0);
  const [pathURL, setPathURL] = useState("");
  const [searchParamsChanged, setSearchParamsChanged] = useState(false);
  const [isDomainAllowed, setIsDomainAllowed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 850);
  const [searchError, setSearchError] = useState(false);

  const isMobileDevice = () => {
    setIsMobile(window.innerWidth <= 850);
  };

  useEffect(() => {
    window.addEventListener('resize', isMobileDevice);

    return () => {
      window.removeEventListener('resize', isMobileDevice);
    };
  }, []);

  const handlePageChangeMobile = () => {
    setPage((prevPage) => prevPage + 1);
    setSearchParamsChanged(true);
  };

  // valida que el dominio pertenezca a clarosports/unotv
  useEffect(() => {
    const domain = window.location.hostname;
    if (domain) {
      const isAllowed = domain.includes("clarosports.com") || domain.endsWith("clarosports.com") || domain.includes("unotv.com") || domain.endsWith("unotv.com") || domain.includes("localhost");
      setIsDomainAllowed(isAllowed);
    }
  }, []);

  useEffect(() => {
    // Handle message from parent to get search parameters
    const handleMessage = (event) => {
      const origin = new URL(event.origin);
      if (origin.hostname.includes('localhost') || origin.hostname.endsWith("clarosports.com") || origin.hostname.includes("clarosports.com") || origin.hostname.includes("unotv.com") || origin.hotsname.endsWith("unotv.com")) {
        setPathURL(event.origin);
        const urlParams = new URLSearchParams(event.data.params);
        setQuery(urlParams.get('q') || '');
        setCategory(urlParams.get('categoria') || '');
        setPage(parseInt(urlParams.get('from'), 10) || 0);
        setSearchParamsChanged(true);
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     const origin = new URL(event.origin);
  //     if (
  //       origin.hostname.includes('localhost') ||
  //       origin.hostname.endsWith('clarosports.com') ||
  //       origin.hostname.includes('clarosports.com') ||
  //       origin.hostname.includes('unotv.com') ||
  //       origin.hostname.endsWith('unotv.com')
  //     ) {
  //       const urlParams = new URLSearchParams(event.data.params);

  //       const newQuery = urlParams.get('q') || '';
  //       const newCategory = urlParams.get('categoria') || '';
  //       const newPage = parseInt(urlParams.get('from'), 10) || 0;

  //       if (newQuery !== query || newCategory !== category || newPage !== page) {
  //         setPathURL(event.origin);
  //         setQuery(newQuery);
  //         setCategory(newCategory);
  //         setPage(newPage);
  //         setSearchParamsChanged(true);
  //       }
  //     }
  //   };

  //   window.addEventListener('message', handleMessage);

  //   return () => {
  //     window.removeEventListener('message', handleMessage);
  //   };
  // }, []);

  useEffect(() => {
    // Synchronize with URL parameters after receiving values from parent
    if (!query && !category && page === 0) {
      const urlParams = new URLSearchParams(window.location.search);
      setQuery(urlParams.get('q') || '');
      setCategory(urlParams.get('category') || '');
      setPage(parseInt(urlParams.get('page'), 10) || 0);
      setSearchParamsChanged(true);
    }
  }, []);

  const sessionId = useCallback(() => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = generateSessionId();
      localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  }, []);

  const callPostToken = useCallback(async () => {
    const id = sessionId();

    if (id && ((!token || token == null)) && (retryCount < 1 && !errorService)) {
      try {
        const response = await postToken({ user_id: id });

        if (response && response.statusCode !== 500 && response.statusCode !== 401) {
          localStorage.setItem('sessionToken', response.data.token);
          setToken(response.data.token);
          setErrorService(prev => false);
          setRetrySearch(true);

          const url = new URL(window.location.href);
          url.searchParams.set('q', query);
          url.searchParams.set('category', category);
          url.searchParams.set('page', page);
          window.history.pushState({}, '', url);

          const search = await getSearch(query, page, PAGESIZE, category, response.data.token);

          if (search && retryCount < 1) {
            if (search.statusCode === 500) {
              setSearchError(prev => true); // Si es 500, detenemos futuros intentos
              setShowLoading(false);
              return;
            }
            if (search.statusCode === 200) {
              setSearchError(prev => false);
            }

            if (isMobile && search.statusCode !== 401) {
              setData(prevData => {
                const safePrevData = prevData || { hits: [] };
                const newHits = Array.isArray(search.data.hits) ? search.data.hits : [];
                const areHitsEqual = safePrevData.hits.length > 0 && newHits.length > 0 && safePrevData.hits[0].title === newHits[0].title;

                return {
                  from: search.data.from,
                  total: search.data.total,
                  hits: areHitsEqual ? [...safePrevData.hits] : [...safePrevData.hits, ...newHits]
                };
              });
            } else if (!isMobile && search.statusCode !== 401) {
              setData(search.data);
            }

            if (search.statusCode === 401 && retryCount < 1 && !searchError) {
              setRetryCount(prev => prev + 1);
              setErrorService(prev => true);
              setSearchError(prev => true);
            }
          } else {
            setData([]);
          }
        }
      } catch (error) {
        console.error('Error al obtener el token:', error);
        // setRetryCount(prev => prev + 1);
        setErrorService(prev => true);
      } finally {
        setShowLoading(false);
      }
    }
  }, [token, errorService, sessionId, query, category, page, pathURL, isMobile]);

  useEffect(() => {
    if (retryCount < 1 && !searchError) {
      callPostToken();
    }
  }, [retryCount, searchError, callPostToken]);

  useEffect(() => {
    if (searchParamsChanged && !searchError) { // <---- Si hay error 500 no intentes más
      setShowLoading(true);
      setSearchParamsChanged(false);

      if (((!token || token === null) && !errorService && retryCount < 1) || (token && errorService && retryCount < 1) && !searchError) {
        callPostToken();
      } else if (token && !errorService && !searchError) {
        const url = new URL(window.location.href);
        url.searchParams.set('q', query);
        url.searchParams.set('category', category);
        url.searchParams.set('page', page);
        window.history.pushState({}, '', url);

        getSearch(query, page, PAGESIZE, category, token)
          .then((search) => {
            if (search) {
              if (search.statusCode === 500) {
                setRetryCount(prev => retryCount + 1);
                setSearchError(prev => true);
                return;
              }

              if (isMobile && search.statusCode !== 401) {
                setData(prevData => {
                  const safePrevData = prevData || { hits: [] };
                  const newHits = Array.isArray(search.data.hits) ? search.data.hits : [];
                  const areHitsEqual = safePrevData.hits.length > 0 && newHits.length > 0 && safePrevData.hits[0].title === newHits[0].title;

                  return {
                    from: search.data.from,
                    total: search.data.total,
                    hits: areHitsEqual ? [...safePrevData.hits] : [...safePrevData.hits, ...newHits]
                  };
                });
              } else if (!isMobile && search.statusCode !== 401) {
                setData(search.data);
              }

              if (search.statusCode === 401) {
                setRetryCount(prev => retryCount + 1);
                setErrorService(true);
              }
            } else {
              setData([]);
              setRetryCount(prev => retryCount + 1);
              setSearchError(prev => true);
            }
          })
          .finally(() => {
            setShowLoading(false);
          });

        sendParams({ q: query, categoria: category, from: page });
        setTimeout(sendHeight, 500);
      }
    }
  }, [token, errorService, retryCount, callPostToken, query, category, page, searchParamsChanged, searchError]);

  // Reinicia los datos si es una nueva búsqueda o si cambia el query
  useEffect(() => {
    if ((query || category) && page === 0 && isMobile) {
      setData(null);
    }
  }, [isMobile, query, category, page])

  const handleQueryChange = (query) => {
    setQuery(query);
    setPage(0);
    setSearchParamsChanged(true);
  };

  // Reset to first page when changing category
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
    setPage(0);
    setSearchParamsChanged(true);
  };

  // Reset to first page when making a new search
  const handleSearch = () => {
    setPage(0);
    setSearchParamsChanged(true);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setSearchParamsChanged(true);
  };

  // Send height for WP resize
  const sendHeight = () => {
    if (pathURL) {
      const container = document.querySelector('.container');
      if (container) {
        const height = container.offsetHeight;
        const data = { type: 'resize', height };
        window.parent.postMessage(data, pathURL);
      }
    }
  };

  // Send search parameters for WP connection
  const sendParams = (params) => {
    if (pathURL) {
      const data = { type: 'params', params };
      window.parent.postMessage(data, pathURL);
    }
  };

  // Update height for resize
  useEffect(() => {
    window.addEventListener('load', sendHeight);
    window.addEventListener('resize', sendHeight);

    return () => {
      window.removeEventListener('load', sendHeight);
      window.removeEventListener('resize', sendHeight);
    };
  }, [pathURL]);

  if (isDomainAllowed === false) {
    return (
      <div id="modalForbbiden" className="forbbiden">
        <h1>Sitio no autorizado</h1>
        {/* <p className="link">Visita: <a href={"https://www"+ dominio +"/"} target="_blank" rel="noopener noreferrer" >{dominio.slice(1)}</a></p> */}
      </div>
    );
  }


  return (
    <div className="container">
      <BusquedaForm
        query={query}
        setQuery={setQuery}
        category={category}
        onQueryChange={handleQueryChange}
        onCategoryChange={handleCategoryChange}
        onSearch={handleSearch}
        token={token}
        retryCount={retryCount}
        setToken={setToken}
        setErrorService={setErrorService}
        setRetrySearch={setRetrySearch}
        setRetryCount={setRetryCount}
        sessionId={sessionId}
        errorService={errorService}
        isMobile={isMobile}
        setData={setData}
      />

      {showLoading && <Loading />}

      {!showLoading && <Resultados data={data} query={query} />}

      {data && data.total > PAGESIZE && !showLoading &&
        <>
          {!isMobile ?
            <Paginacion
              currentPage={page}
              total={data ? data.total : 0}
              pageSize={PAGESIZE}
              onPageChange={handlePageChange}
            />
            :
            <PaginacionMobile
              currentPage={page}
              total={data ? data.total : 0}
              pageSize={PAGESIZE}
              onPageChange={handlePageChangeMobile}
            />
          }
        </>
      }
    </div>
  );
}